module.exports = __webpack_public_path__ + "static/img/compro_help1.d687d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compro_help1.png
// module id = VAYI
// module chunks = 1